import React from "react";
import { FaMicrophone } from "react-icons/fa";

const InputField = ({ label, name, value, onChange, type = "text", autoFocus = false, disabled = false, microphone = false, required = false }) => {
    return (
        <div className="mt-2" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "80%" }}>
                <div style={{ fontFamily: "sans-serif", fontSize: "12px", fontWeight: "bold" }}>
                    {label} {required && <span style={{ color: "red" }}>*</span>}
                </div>
                <div style={{ border: "1px solid #D1D1D1", borderRadius: "5px" }}>
                    {type === "textarea" ? (
                        <textarea
                            name={name}
                            value={value || ''}
                            onChange={onChange}
                            style={{
                                padding: "5px",
                                outline: "none",
                                width: "100%",
                                border: "none",
                                height: "60px",
                                resize: "vertical"
                            }}
                            disabled={disabled}
                        />
                    ) : (
                        <input
                            type={type}
                            name={name}
                            value={value || ''}
                            onChange={onChange}
                            style={{
                                padding: "5px",
                                outline: "none",
                                width: "100%",
                                border: "none"
                            }}
                            disabled={disabled}
                            autoFocus={autoFocus}
                        />
                    )}
                </div>
                {microphone && (
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "5px" }}>
                        <div
                            style={{
                                padding: "3px 6px",
                                backgroundColor: "#66B2FF",
                                borderRadius: "4px",
                                cursor: "pointer"
                            }}
                        >
                            <FaMicrophone style={{ color: "white", fontSize: "14px" }} />
                        </div>
                    </div>
                )}
                
            </div>
        </div>
    );
};

export default InputField;
